import {
  FlexColumn,
  FlexRow,
  LabeledInput,
  MaterialIcon,
  StyledBanner,
  StyledButton,
} from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { changePassword } from '../../services/accountService';
import { User } from '../../types/user';
import { validatePassword } from '../../utils/password';

type Props = {
  onCancel: (changePassword: boolean) => void;
  user?: User;
};

export function ChangePasswordForm({ onCancel, user }: Props) {
  const { css, classes, theme } = useStyles();
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { showPositiveFeedback } = useFeedback();

  const passwordValidation = (errors: string) => {
    if (!newPassword) return;
    const hasErrors = validatePassword(newPassword, { oldPassword: password, repeatPassword: confirmNewPassword });
    if (!hasErrors) return;
    return hasErrors[errors];
  };

  const validateForm = () => {
    if (!!password && !!newPassword && !!confirmNewPassword) {
      if (!!passwordValidation('errors') || !!passwordValidation('repeatPasswordErrors')) return false;
      return true;
    }
    return false;
  };

  const submitForm = async () => {
    if (!validateForm()) return;
    setLoading(true);
    const response = await changePassword({
      body: {
        oldPassword: password,
        newPassword: newPassword,
      },
    });
    if (response?.error) {
      setError(`${response.error}`);
    } else {
      onCancel(false);
      showPositiveFeedback('Se actualizó su contraseña correctamente.');
    }
    setLoading(false);
  };

  return (
    <>
      <FlexColumn classNames={css({ flex: 1 })}>
        <LabeledInput
          label="Contraseña Anterior"
          placeholder="Ingresa tu contraseña anterior"
          value={password}
          onChange={setPassword}
          type="password"
          startEnhancer={<MaterialIcon name="lock" />}
          required
        />
        <LabeledInput
          label="Contraseña Nueva"
          placeholder="Ingresa tu nueva contraseña"
          value={newPassword}
          onChange={(e) => {
            setConfirmNewPassword('');
            setNewPassword(e);
          }}
          type="password"
          startEnhancer={<MaterialIcon name="lock" />}
          error={!!newPassword && passwordValidation('errors')}
          required
        />
        <LabeledInput
          label="Repetir contraseña"
          placeholder="Confirma tu nueva contraseña"
          value={confirmNewPassword}
          onChange={setConfirmNewPassword}
          type="password"
          startEnhancer={
            <MaterialIcon
              name="lock"
              color={newPassword ? theme.colors.contentPrimary : theme.colors.contentStateDisabled}
            />
          }
          disabled={!newPassword}
          disabledViewOption
          error={!!confirmNewPassword && passwordValidation('repeatPasswordErrors')}
          required
        />
        {error && (
          <StyledBanner
            title="*Error*"
            kind="negative"
            full
            action={{
              label: 'Label',
              onClick: () => {
                setError('');
              },
            }}
          >
            {error}
          </StyledBanner>
        )}
      </FlexColumn>
      <FlexRow classNames={classes.centeredEnd}>
        <StyledButton
          onClick={() => onCancel(false)}
          kind="tertiary"
        >
          Cancelar
        </StyledButton>
        <StyledButton
          onClick={() => submitForm()}
          isLoading={loading}
          disabled={!validateForm()}
        >
          Guardar
        </StyledButton>
      </FlexRow>
    </>
  );
}
